var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.228,
    height: 14.538,
    viewBox: "0 0 17.228 14.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "switch",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M3.589,7.178A3.589,3.589,0,1,1,7.178,3.589,3.593,3.593,0,0,1,3.589,7.178Zm0-6.1A2.512,2.512,0,1,0,6.1,3.589,2.515,2.515,0,0,0,3.589,1.077Zm0,0",
    transform: "translate(0 1)",
    fill: "#94c0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M173.609,41.419h-8.793a.512.512,0,1,1,0-1.022h8.793a1.023,1.023,0,1,0,0-2.044h-9.016a.512.512,0,1,1,0-1.022h9.016a2.046,2.046,0,1,1,0,4.087Zm0,0",
    transform: "translate(-158.535 -34.966)",
    fill: "#94c0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M302.257,263.178a3.589,3.589,0,1,1,3.589-3.589A3.593,3.593,0,0,1,302.257,263.178Zm0-6.1a2.512,2.512,0,1,0,2.512,2.512A2.515,2.515,0,0,0,302.257,257.077Zm0,0",
    transform: "translate(-288.618 -247.641)",
    fill: "#94c0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M10.947,297.295H2.153a1.988,1.988,0,1,1,0-3.963h9.016a.5.5,0,1,1,0,.991H2.153a.994.994,0,1,0,0,1.981h8.793a.5.5,0,1,1,0,.991Zm0,0",
    transform: "translate(0 -283.544)",
    fill: "#94c0d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.ddc0ffe95861dd1697d045136e0fb0ea.svg";
export { ForwardRef as ReactComponent };